import React, { useState } from 'react';
import './app.less';
import { RS } from './Routes'
import { LayoutHeader } from './components/LayoutHeader'
import styled from 'styled-components'
import { Col, Row } from 'antd';
import { Home } from './components/Home'

const HeaderContainer = styled(Row)`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 9999999;
  border-bottom: 1px solid #f3f3f3;
  background-color: #fff;
`
const MainContainer = styled(Row)`
`

function App() {
  return (
    <>
      <HeaderContainer justify="center">
        <Col span={24} lg={16}>
            <LayoutHeader></LayoutHeader>
        </Col>
      </HeaderContainer>
      <MainContainer justify="center">
        <Col span={24} lg={16}>
            <Home></Home>
        </Col>
      </MainContainer>
    </>
  );
}

export default App;
